import { useEffect, useState } from "react";
import { useQuote } from "./QuoteContext";
import { addDoc, collection, doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../Admin/Config/Config";
import { onAuthStateChanged } from "firebase/auth";
import { useLoginPopup } from "../../Auth/LoginContext";

export default function QuotePopup() {
  const { isOpen, closeQuote, selectedProduct } = useQuote();
  const product = selectedProduct;
  const { openPopup } = useLoginPopup();
  const [showList, setShowList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [qty, setQty] = useState(1);
   const [formData, setFormData] = useState({
     name:  "",
     email:  "",
     mobile:  "",
     company: "",
     address: "",
     city: "",
     province: "",
     postal: "",
     message: "",
     usage: "",
   });
   // =============================== Clearing the form ================================ //
   const clearForm = () => {
    setFormData({
      name: "",
      email: "",
      mobile: "",
      company: "",
      address: "",
      city: "",
      province: "",
      postal: "",
      message: "",
      usage: "",
    });
    closeQuote();
  };

    // ================================ USER DETAILS ================================ //
     useEffect(() => {
       onAuthStateChanged(auth, async (user) => {
         if (user) {
           const userRef = doc(db, "users", user.uid);
           const userDoc = await getDoc(userRef);

           if (userDoc.exists()) {
             const userData = userDoc.data();
             setFormData({
               name: userData.name,
               email: userData.email,
               mobile: userData.mobile,
               company: "",
               address: "",
               city: "",
               province: "",
               postal: "",
               message: "",
               usage: "",
               uid: user.uid,
               status: "requested",
               createdAt: new Date(),
             });}
         } else {
          clearForm();
          if (!isOpen) return;
          openPopup();
         }
       });
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [isOpen]);

 

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleQuantity = (type) => {
   setQty((prevQty) =>
     type === "inc" ? prevQty + 1 : Math.max(1, prevQty - 1)
   );
 };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await addDoc(collection(db, "quote_requests"), {
      ...formData,
      products: selectedProduct.cart?selectedProduct.products:[{...selectedProduct,cart_quantity:qty}],
      cart: selectedProduct.cart?true:false,
    });
    alert("Quote request submitted successfully!");
    clearForm();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[760px] h-[80vh] relative animate-fadeIn flex flex-col">
        {/* Close button */}
        <button
          onClick={clearForm}
          className="absolute top-4 right-4 text-gray-500 hover:text-red-600 transition"
        >
          ✕
        </button>

        {/* Header - Fixed */}
        <div className="p-4 pb-3 border-b border-gray-200 flex-shrink-0">
          <h2 className="text-lg font-bold text-gray-800 pr-8">
            Request a Quote
          </h2>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-4">
        {/* Product Section */}
        {selectedProduct?.cart ? (
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
              Selected Products
              <button
                onClick={() => setShowList(!showList)}
                className="text-blue-600 underline hover:text-blue-800 bg-transparent border-none px-0 py-0 text-sm font-medium cursor-pointer"
                style={{ background: "none", boxShadow: "none" }}
              >
                {showList ? "Hide List" : "View List"}
              </button>
            </h3>

            <div className="overflow-hidden rounded-lg border border-gray-200 shadow-sm">
              {showList && (
                <table className="w-full text-sm">
                  <thead className="bg-gray-100 text-gray-700">
                    <tr>
                      <th className="px-4 py-3 text-left font-medium">Name</th>
                      <th className="px-4 py-3 text-left font-medium">
                        Category
                      </th>
                      <th className="px-4 py-3 text-left font-medium">
                        Quantity
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {selectedProduct.products?.map((product, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3">
                          {product?.product_name || "Sample"}
                        </td>
                        <td className="px-4 py-3">
                          {product?.category || "N/A"}
                        </td>
                        <td className="px-4 py-3">
                          {product?.cart_quantity || "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        ) : (
          <div className="border border-gray-200 rounded-xl p-4 mb-4 shadow-sm">
            <div className="flex flex-col md:flex-row items-start gap-4 mb-4">
              <img
                src={product?.thumb_url || "https://via.placeholder.com/80"}
                alt={product?.product_name}
                className="w-20 h-20 object-contain rounded-lg border mx-auto md:mx-0"
              />
              <div className="flex-1 text-center md:text-left">
                <h3 className="font-semibold text-gray-800 text-base">
                  {product?.name || "Sample Product"}
                </h3>
                <p className="text-gray-500 text-sm">
                  Category: {product?.category || "N/A"}
                </p>
                <p className="text-gray-500 text-sm">
                  {product?.sub_category || "N/A"}
                </p>
              </div>
              {/* Quantity */}
              <div className="flex items-center justify-center md:justify-end">
                <div className="flex items-center border rounded-lg overflow-hidden bg-white shadow-sm">
                  <button
                    type="button"
                    onClick={() => handleQuantity("dec")}
                    className="px-3 py-2 text-lg hover:bg-gray-100 transition-colors flex items-center justify-center"
                  >
                    −
                  </button>
                  <span className="px-4 py-2 font-medium text-base min-w-[3rem] text-center border-x border-gray-200">{qty}</span>
                  <button
                    type="button"
                    onClick={() => handleQuantity("inc")}
                    className="px-3 py-2 text-lg hover:bg-gray-100 transition-colors flex items-center justify-center"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            {/* Usage Frequency - Full Width */}
            <textarea
              name="usage"
              placeholder="How often do you order this item?"
              value={formData.usage}
              onChange={handleChange}
              rows="3"
              className="w-full border border-gray-300 rounded-lg p-3 text-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 focus:outline-none bg-white shadow-sm resize-none transition-all duration-200 hover:border-gray-400"
            />
          </div>
        )}

        {/* Customer Info */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <h3 className="text-base font-semibold text-gray-700">
            Customer Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { name: "name", type: "text", placeholder: "Full Name *" },
              { name: "email", type: "email", placeholder: "Email *" },
              { name: "company", type: "text", placeholder: "Company Name *" },
              { name: "mobile", type: "tel", placeholder: "Phone Number *" },
              {
                name: "address",
                type: "text",
                placeholder: "Business Address *",
              },
              { name: "city", type: "text", placeholder: "City *" },
              { name: "province", type: "text", placeholder: "Province *" },
              { name: "postal", type: "text", placeholder: "Postal Code *" },
            ].map((field, idx) => (
              <input
                key={idx}
                type={field.type}
                name={field.name}
                placeholder={field.placeholder}
                value={formData[field.name]}
                onChange={handleChange}
                required
                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-red-500 focus:outline-none"
              />
            ))}
          </div>

          <textarea
            name="message"
            placeholder="Message (optional)"
            value={formData.message}
            onChange={handleChange}
            rows="3"
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-red-500 focus:outline-none"
          ></textarea>

          <button
            type="submit"
            className={`w-full bg-red-600 text-white py-3 rounded-lg font-semibold shadow-md hover:bg-red-700 transition flex items-center justify-center ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
                Submitting...
              </>
            ) : (
              "Submit Request"
            )}
          </button>
        </form>
        </div>
      </div>
    </div>
  );
}
